
import {
  BlockText,
  BlockCTA,
  BlockRelatedContent,
  BlockNewsletterBlock,
} from '../implementations';

const mappers = {
  text: BlockText,
  cta: BlockCTA,
  related_content: BlockRelatedContent,
  newsletter: BlockNewsletterBlock,
};

export default mappers;

